/** @flow */

import {
  GetRevisionHistorySuccess,
  GetRevisionHistoryError,
  GetEmployeeSMSMessagesSuccess,
  GetEmployeeAbsences,
  GetEmployeeAbsencesSuccess,
  GetAlertsTriggered,
  GetAlertsTriggeredSuccess,
  GetAlertsTriggeredError,
  CancelAlert,
  CancelAlertSuccess,
  CancelAlertError,
  ToggleAlertsTriggeredModal,
  ToggleAddAbsenceModal,
  ToggleTransferAbsenceModal,
  UpdateAbsenceAddModalData,
  GetEmployeeAbsencesSchemaSuccess,
  GetEmployeeAbsence,
  GetEmployeeAbsenceSuccess,
  UpdateEmployeeAbsence,
  UpdateEmployeeAbsenceSuccess,
  UpdateEmployeeAbsenceError,
  GetEmployeeAbsenceShiftPattern,
  GetEmployeeAbsenceShiftPatternSuccess,
  GetEmployeeAbsenceShiftPatternOptions,
  GetEmployeeAbsenceShiftPatternOptionsSuccess,
  ToggleEmployeeAbsenceShiftPatternModal,
  GetEmployeeInteractionsSuccess,
  ToggleEditEmployeeInteractionModal,
  GetEmployeeAbsenceAdditionalInfoSuccess,
  ToggleEditEmployeeAbsenceAdditionalInfoModal,
  GetAbsenceStatistics,
  GetAbsenceStatisticsSuccess,
  GetAbsenceStatisticsError,
  GetEmployeeAbsenceDocumentsSuccess,
  ToggleEmployeeAbsenceDocumentModal,
  ToggleDeleteEmployeeAbsenceDocumentModal,
  GetManagerNotesSuccess,
  GetManagerNotesError,
  GetEmployeeAbsenceNotificationsSuccess,
  ToggleEmployeeAbsenceNotificationModal,
  ToggleAddEditManagerNotesModal,
  GetAbsenceManagerNotesSchemaSuccess,
  SetVisibleAbsenceRateTrendRTWInterviewModal,
  GetEmployeeNonCancelledAbsencesSuccess,
  GetAbsenceNoteTypesSuccess,
  ToggleTransferAbsenceConfirmationModal,
  SubmitTransferAbsence,
  SubmitTransferAbsenceSuccess,
  SubmitTransferAbsenceError,
  ToggleDeleteManagerNoteModal,
  AddManagerNote,
  AddManagerNoteSuccess,
  AddManagerNoteError,
  DeleteManagerNote,
  DeleteManagerNoteSuccess,
  DeleteManagerNoteError,
  EditManagerNote,
  EditManagerNoteSuccess,
  EditManagerNoteError,
  GetManagerNotes,
  ExportManagerNotes,
  ExportManagerNotesSuccess,
  ExportManagerNotesError,
  UpdateEmployeeInteraction,
  UpdateEmployeeInteractionSuccess,
  UpdateEmployeeInteractionError,
  UpdateEmployeeAbsenceShiftPattern,
  UpdateAbsence,
  UpdateAbsenceSuccess,
  UpdateAbsenceError,
  CreateAbsence,
  CreateAbsenceSuccess,
  CreateAbsenceError,
  UpdateEmployeeAbsenceShiftPatternSuccess,
  UpdateEmployeeAbsenceShiftPatternError,
  GetEmployeeAbsenceNotification,
  GetEmployeeAbsenceNotificationSuccess,
  GetEmployeeAbsenceNotificationError,
  CreateEmployeeAbsenceDocument,
  CreateEmployeeAbsenceDocumentSuccess,
  CreateEmployeeAbsenceDocumentError,
  DeleteEmployeeAbsenceDocument,
  DeleteEmployeeAbsenceDocumentSuccess,
  DeleteEmployeeAbsenceDocumentError,
  GetEmployeeAbsenceDocument,
  GetEmployeeAbsenceDocumentSuccess,
  GetEmployeeAbsenceDocumentError,
  GetEmployeeBankHolidaysOptionsSuccess,
  GetAbsenceTimeLostSuccess,
  SharedSetLoading,
  SharedSetLoaded,
  DeleteEmployeeAbsence,
  DeleteEmployeeAbsenceSuccess,
  DeleteEmployeeAbsenceError,
  CancelEmployeeAbsence,
  CancelEmployeeAbsenceSuccess,
  CancelEmployeeAbsenceError,
  GetAbsenceCancelReasonsSuccess,
  GetAbsenceCancelReasonsError,
  GetEmployeeAbsenceByIdSuccess,
} from "@modules/shared/constants/actions";
import * as reducers from "./reducers";
import type { AbsencesState } from "./types";
import initialState from "./state";
import { cloneObject } from "@utils/object";

export default (state: AbsencesState = initialState, action: any): Object => {
  const act = {
    [SharedSetLoading]: reducers.onSharedSetLoading,
    [SharedSetLoaded]: reducers.onSharedSetLoaded,
    [GetAbsenceTimeLostSuccess]: reducers.onGetAbsenceTimeLostSuccess,
    [GetRevisionHistorySuccess]: reducers.onGetRevisionHistorySuccess,
    [GetEmployeeSMSMessagesSuccess]: reducers.onGetEmployeeSMSMessagesSuccess,
    [GetRevisionHistoryError]: reducers.onGetRevisionHistoryError,
    [GetEmployeeAbsence]: reducers.onGetEmployeeAbsence,
    [GetEmployeeAbsenceSuccess]: reducers.onGetEmployeeAbsenceSuccess,
    [GetEmployeeAbsenceByIdSuccess]: reducers.onGetEmployeeAbsenceSuccess,
    [GetEmployeeAbsences]: reducers.onGetEmployeeAbsences,
    [GetEmployeeAbsencesSuccess]: reducers.onGetEmployeeAbsencesSuccess,
    [GetAlertsTriggered]: reducers.setLoading,
    [GetAlertsTriggeredSuccess]: reducers.onGetAlertsTriggeredSuccess,
    [GetAlertsTriggeredError]: reducers.onGetAlertsTriggeredError,

    [CancelAlert]: reducers.setLoading,
    [CancelAlertSuccess]: reducers.setLoaded,
    [CancelAlertError]: reducers.setLoaded,

    [ToggleAlertsTriggeredModal]: reducers.onToggleAlertsTriggeredModal,
    [ToggleAddAbsenceModal]: reducers.onToggleAddAbsenceModal,
    [ToggleTransferAbsenceModal]: reducers.onToggleTransferAbsenceModal,
    [ToggleTransferAbsenceConfirmationModal]: reducers.onToggleTransferAbsenceConfirmationModal,
    [SubmitTransferAbsence]: reducers.onSubmitTransferAbsence,
    [SubmitTransferAbsenceSuccess]: reducers.onSubmitTransferAbsenceSuccess,
    [SubmitTransferAbsenceError]: reducers.onSubmitTransferAbsenceError,
    [UpdateAbsenceAddModalData]: reducers.onUpdateAbsenceAddModalData,
    [GetEmployeeAbsencesSchemaSuccess]: reducers.onGetEmployeeAbsencesSchemaSuccess,
    [UpdateEmployeeAbsence]: reducers.setLoading,
    [UpdateEmployeeAbsenceSuccess]: reducers.onUpdateEmployeeAbsenceSuccess,
    [UpdateEmployeeAbsenceError]: reducers.onUpdateEmployeeAbsenceError,
    [GetEmployeeAbsenceShiftPattern]: reducers.setLoading,
    [GetEmployeeAbsenceShiftPatternSuccess]: reducers.onGetEmployeeAbsenceShiftPatternSuccess,
    [GetEmployeeAbsenceShiftPatternOptions]: reducers.setLoading,
    [GetEmployeeAbsenceShiftPatternOptionsSuccess]:
      reducers.onGetEmployeeAbsenceShiftPatternOptionsSuccess,
    [ToggleEmployeeAbsenceShiftPatternModal]: reducers.onToggleEmployeeAbsenceShiftPatternModal,
    [GetEmployeeInteractionsSuccess]: reducers.onGetEmployeeInteractionsSuccess,
    [ToggleEditEmployeeInteractionModal]: reducers.onToggleEditEmployeeInteractionModal,
    [GetEmployeeAbsenceAdditionalInfoSuccess]: reducers.onGetEmployeeAbsenceAdditionalInfoSuccess,
    [ToggleEditEmployeeAbsenceAdditionalInfoModal]:
      reducers.onToggleEditEmployeeAbsenceAdditionalInfoModal,
    [GetAbsenceStatistics]: reducers.setLoading,
    [GetAbsenceStatisticsSuccess]: reducers.onGetAbsenceStatisticsSuccess,
    [GetAbsenceStatisticsError]: reducers.onGetAbsenceStatisticsError,
    [GetEmployeeAbsenceDocumentsSuccess]: reducers.onGetEmployeeAbsenceDocumentsSuccess,
    [ToggleEmployeeAbsenceDocumentModal]: reducers.onToggleEmployeeAbsenceDocumentModal,
    [ToggleDeleteEmployeeAbsenceDocumentModal]: reducers.onToggleDeleteEmployeeAbsenceDocumentModal,
    [GetManagerNotes]: reducers.setLoading,
    [GetManagerNotesSuccess]: reducers.onGetManagerNotesSuccess,
    [GetManagerNotesError]: reducers.onGetManagerNotesError,
    [GetEmployeeAbsenceNotificationsSuccess]: reducers.onGetEmployeeAbsenceNotificationsSuccess,
    [ToggleEmployeeAbsenceNotificationModal]: reducers.onToggleEmployeeAbsenceNotificationModal,
    [ToggleAddEditManagerNotesModal]: reducers.onToggleAddEditManagerNotesModal,
    [ToggleDeleteManagerNoteModal]: reducers.onToggleDeleteManagerNoteModal,
    [GetAbsenceManagerNotesSchemaSuccess]: reducers.onGetAbsenceManagerNotesSchemaSuccess,
    [SetVisibleAbsenceRateTrendRTWInterviewModal]:
      reducers.onSetVisibleAbsenceRateTrendRTWInterviewModal,
    [GetEmployeeNonCancelledAbsencesSuccess]: reducers.onGetEmployeeNonCancelledAbsencesSuccess,
    [GetAbsenceNoteTypesSuccess]: reducers.onGetAbsenceNoteTypesSuccess,
    [AddManagerNote]: reducers.setLoading,
    [AddManagerNoteSuccess]: reducers.setLoaded,
    [AddManagerNoteError]: reducers.setLoaded,
    [DeleteManagerNote]: reducers.setLoading,
    [DeleteManagerNoteSuccess]: reducers.setLoaded,
    [DeleteManagerNoteError]: reducers.setLoaded,
    [EditManagerNote]: reducers.setLoading,
    [EditManagerNoteSuccess]: reducers.setLoaded,
    [EditManagerNoteError]: reducers.setLoaded,
    [ExportManagerNotes]: reducers.setLoading,
    [ExportManagerNotesSuccess]: reducers.setLoaded,
    [ExportManagerNotesError]: reducers.setLoaded,
    [UpdateEmployeeInteraction]: reducers.setLoading,
    [UpdateEmployeeInteractionSuccess]: reducers.setLoaded,
    [UpdateEmployeeInteractionError]: reducers.setLoaded,

    [UpdateAbsence]: reducers.setLoading,
    [UpdateAbsenceSuccess]: reducers.onUpdateAbsenceSuccess,
    [UpdateAbsenceError]: reducers.setLoaded,
    [CreateAbsence]: reducers.setLoading,
    [CreateAbsenceSuccess]: reducers.setLoaded,
    [CreateAbsenceError]: reducers.setLoaded,

    [UpdateEmployeeAbsenceShiftPattern]: reducers.setLoading,
    [UpdateEmployeeAbsenceShiftPatternSuccess]: reducers.onGetAbsenceTimeLostSuccess,
    [UpdateEmployeeAbsenceShiftPatternError]: reducers.setLoaded,
    [GetEmployeeAbsenceNotification]: reducers.setLoading,
    [GetEmployeeAbsenceNotificationSuccess]: reducers.setLoaded,
    [GetEmployeeAbsenceNotificationError]: reducers.setLoaded,
    [CreateEmployeeAbsenceDocument]: reducers.setLoading,
    [CreateEmployeeAbsenceDocumentSuccess]: reducers.setLoaded,
    [CreateEmployeeAbsenceDocumentError]: reducers.setLoaded,
    [DeleteEmployeeAbsenceDocument]: reducers.setLoading,
    [DeleteEmployeeAbsenceDocumentSuccess]: reducers.setLoaded,
    [DeleteEmployeeAbsenceDocumentError]: reducers.setLoaded,
    [GetEmployeeAbsenceDocument]: reducers.setLoading,
    [GetEmployeeAbsenceDocumentSuccess]: reducers.setLoaded,
    [GetEmployeeAbsenceDocumentError]: reducers.setLoaded,
    [GetEmployeeBankHolidaysOptionsSuccess]: reducers.onGetEmployeeBankHolidaysOptionsSuccess,
    [DeleteEmployeeAbsence]: reducers.setLoading,
    [DeleteEmployeeAbsenceSuccess]: reducers.setLoaded,
    [DeleteEmployeeAbsenceError]: reducers.setLoaded,
    [CancelEmployeeAbsence]: reducers.setLoading,
    [CancelEmployeeAbsenceSuccess]: reducers.setLoaded,
    [CancelEmployeeAbsenceError]: reducers.setLoaded,
    [GetAbsenceCancelReasonsSuccess]: reducers.onGetAbsenceCancelReasonsSuccess,
    [GetAbsenceCancelReasonsError]: reducers.setLoaded,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
